<template>
  <div class="home">
    This is community index view
    <router-view></router-view>
  </div>
</template>

<script>

export default {
    name: 'community'
};
</script>
